import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "academic-years",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "academic-years" */ "./components"),
    ])
      .then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
  childRoutes: [],
});
